//package imports 
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";

//componenet imports
import { CusotomSearch } from "../../utils/resuableComponents/CustomSearch";
import CustomTable from "../../utils/resuableComponents/CustomTable";
import CustomModal from "../../utils/resuableComponents/CustomModal";
import { CustomMutilevelDropdown } from "../../utils/resuableComponents/Filters";
import { GetUserList,draftStoreDetails,disableUser } from "../../services/apiServices/PostServices";
import {getUserType ,servicesList,getStateList} from "../../services/apiServices/GetServices";
import { getData } from "../../utils/AsyncStorage";
import { showToast } from "../../utils/constants/Toaster";
import { columnsUserList,columnsStoresList,} from "../../utils/constants/TableHeader";
import Loader from "../loadingScreens/Loader";

const StoreManagement = (props) => {
    const { role } = JSON.parse(getData("userInfo") || 0);
    const [simpleModal, setSimpleModal] = useState(false)
    const [filteredData, setFilteredData] = useState([])
    const [storeData, setStoreData] = useState([])
    const [userTypeData,setUserTypeData]=useState([])
    const [cityListData,setCityListData]=useState([])
    const [serviceListData,setServiceListData]=useState([])
    const [storeTabToggle,setStoreTabToggle]=useState(1)
    const [searchTerm, setSearchTerm] = useState('');
    const [stateData,setStatesData]=useState([])
    const [filtersApplied,setFiltersApplied]=useState(false)
    const [subHeading,setSubHeading]=useState("")
    const [data,setData]=useState([])
    const [storeId,setStoreId]=useState("")
    const [statusChecked,setStatuschecked]=useState(1)
    const [modalContentData,setModalContentData]=useState("")
    const history = useHistory();
    const [isLoader,setIsLoader]=useState(false)

    const pathName = "/admin/storeManagement/storeDetails"
    
    const tabCheck = props?.location?.state?.isPublished

    useEffect(() => {
        callUserTypelistApi()
        callServicelistApi()
        callStateslistApi()
    }, []);

    useEffect(() => {
        if(storeTabToggle===1){
            getStoresListApi()
            setSubHeading("Published Store")
            setSearchTerm('')
        }else{
            getDraftListApi()
            setSubHeading("Draft Store")
            setSearchTerm('')
        }
    }, [storeTabToggle]);
    
    useEffect(() => {
        if (filteredData.length != 0) {
            setData(filteredData)
        }
    }, [filteredData.length])

    useEffect(() => {
        if (tabCheck !== undefined) {
            setStoreTabToggle(tabCheck)
        }
    }, [tabCheck])


     //function to call api of the getUserList
     const getStoresListApi = async () => {
        try {
            const reqbody = {
                type: "",
                city:"",
                is_active:""
            }
            const res = await GetUserList("storeList", reqbody);
            if (res.success) {
                // setFilteredData(res?.data)
                const publishedData = res?.data.filter((data) => data?.is_published === 1)
                if(storeTabToggle === 1){
                    setFilteredData(publishedData)
                    setStoreData(publishedData)
                }
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }
        
    }

      //function to call api of the getUserList
      const getDraftListApi = async () => {
        try{
            const reqbody = {
                type: "",
                city:"",
                is_active:""
            }
            const res = await draftStoreDetails("storeList", reqbody);
            if (res.success) {
                const draftData = res?.data.filter((data) => data?.is_published === 0 )
                    setFilteredData(draftData)
                    setStoreData(draftData)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log("error",error)
        }  
    }


    //function to close modal 
    const closeSimpleModal = () => {
        // setOnclickNo(true)
        setSimpleModal(false)
    }

    //function to change modal content  
    const handleModalContent = (val) =>{
        if(val === 1){
         setModalContentData("Are you sure want to enable the store?")
        }else{
         setModalContentData("Are you sure want to disable the store?")
        }
     }
     
    const handleDisableStoreApi = async ()=> {
        try{
            const reqBody = {
                id : storeId,
                is_active: statusChecked
            }
             const res = await disableUser(`disableStore`,reqBody);
             if (res?.success) {
                 setSimpleModal(false)
                 showToast(1,res?.message)
                 getStoresListApi()
                 
             } else {
                 //showToast(3, res?.message)
                 console.log("res",res?.message)
             }
        }catch(error){
            console.log("error",error)
        }
          
    }

    const handledisableStore = async (check,data) => {
        setStatuschecked(check)
        setStoreId(data?.id)
        handleModalContent(check)
        setSimpleModal(true)
    }

     //function to call list api
     const callStateslistApi = async () => {
        try{
            const res = await getStateList("state/1")
            if (res?.success) {
                setStatesData(res?.data)
            } else {
                console.log("res", res?.message)
            }
        }catch(error){
            console.log(error)
        }
    }

    //function to handle tab
    const handleTabPublishedStore = () => {
      setStoreTabToggle(1)
    } 
    
    //function to handle tab onclick
    const handleTabDraftStore = () => {
        setStoreTabToggle(0)
      } 

//function to userType type api
const callUserTypelistApi = async () => {
    try{
        const res = await getUserType("userType")
        if (res?.success) {
            setUserTypeData(res?.data)
        } else {
            console.log("res", res?.message)
        }
    }catch(error){
        console.log(error)
    }
}

//function call to get service list 
const callServicelistApi = async () => {
    setIsLoader(true)
    try{
        const res = await servicesList("services")
        if (res?.success) {
            setServiceListData(res?.data)
        } else {
            console.log("res", res?.message)
        }
    }catch(error){
        console.log(error)
    }
}

//function to handle getStoresList api
const handleReqbody = async (reqBody) => {
    try{
        const reqbody = reqBody?.city ==="" && reqBody?.is_active === "" ? reqBody :reqBody    
        const res =  storeTabToggle === 1  ?  await GetUserList("storeList", reqbody) : await draftStoreDetails("storeList", reqbody)
          if(res?.success){
              setFilteredData(res?.data)
              setFiltersApplied(true)
              setStoreData(res?.data)
          }else{
              console.log("res",res?.message)
          }
    }catch(error){
        console.log("error",error)
    }
}
     
 //function to clear applied filter
 const handleClear = () => {
    if(storeTabToggle === 1){
        getStoresListApi()
    }else{
        getDraftListApi()
    }
}

// function call to navigate to add store page
const handleAddStoreForm = () => {
    history.push('/admin/storeManagement/addStoreForm')
}

    //function to hanlde search
    const handleSearch = (val) => {
        const searchVal = val
        if (searchVal === "") {
            if(filtersApplied ){
                setStoreData(filteredData)
            }else{
                if(storeTabToggle === 1){
                    getStoresListApi()
                }else{
                    getDraftListApi()
                }
            }
        } else {
            setSearchTerm(searchVal);
            const filterdata = storeData.filter((item) => {
                if (item?.name.toLowerCase()
                    .includes(searchVal.toLowerCase()) || item?.service_name.toLowerCase()
                    .includes(searchVal.toLowerCase()) || item?.city_name.toLowerCase()
                    .includes(searchVal.toLowerCase()) || item?.email.includes(searchVal) || item?.phone_number.includes(searchVal)) { return item; }
            })
            setFilteredData(filterdata)
        }
    }

    return (
        <div class="col-md-12 " >
            {isLoader ? <Loader/> : null}
            <div>
            <div class="d-flex flex-row justify-content-between align-items-center w-100 border-bottom  p-2">
            <div class="d-flex flex-row  align-items-center ">
            <h1 class="fs-4 ms-3 Montserrat fw-semi-bold">
            Store Management
            </h1>
            <h6 class="h-25  m-0 fs-6 roboto fw-semi-bold">
            <i class="fas fa-chevron-right fa-xs mx-1"></i>
             {`${subHeading}`}
            </h6>
            </div>

            <div class="d-flex flex-row">
                <div class="d-flex mx-2 pointer " onClick={handleAddStoreForm} >
                    <h6 class="secondColor d-flex justify-content-center align-items-center fw-bold mx-2 m-0 w-100">
                    Add Store
                    </h6>
                    <i class="bi bi-plus-square colorPrimary"></i>
                </div>
                <CustomMutilevelDropdown  reqBody={handleReqbody} clear={handleClear}  userType= {userTypeData} serviceData={serviceListData} stateData={stateData} from={"Store Management"} toggle={storeTabToggle}/> 
            </div>
        </div>
        
        <div class="d-flex  ">
            <div class="d-flex  w-75">
             <div class={storeTabToggle === 1 ?"mx-4  roboto tabBorder pointer h-50 my-2 align-self-end" :"mx-4 h-50 my-2 align-self-end  roboto pointer"  } onClick={handleTabPublishedStore}>
                <h5 class= {storeTabToggle === 1 ? "fw-bold m-0" : "status-pending m-0"}>Published Store</h5>
             </div>
             <div class={storeTabToggle === 0 ? "  roboto tabBorder pointer h-50 my-2 align-self-end" :" h-50 my-2 align-self-end  roboto pointer" } onClick={handleTabDraftStore}>
                <h5 class={storeTabToggle === 0 ?"fw-bold m-0" : "status-pending m-0"}>Draft Store</h5>
             </div>
             </div>
             <CusotomSearch onChange={handleSearch} searchVal={searchTerm} />
        </div>
        <CustomTable  path={pathName} data={filteredData} columnHeader={columnsStoresList} openStoreDisable={handledisableStore}  />
     
        <CustomModal
            close={closeSimpleModal}
            open={simpleModal}
            modalContent={modalContentData}
             Action={handleDisableStoreApi}
             statusCheck={statusChecked}
        />
            </div>
    </div>
    )
}

export default StoreManagement